import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { BehaviorSubject, Observable, throwError } from 'rxjs';
import { CrudService } from "./crud.service";
import {ComunidadPublicacion, ComunidadPublicacionAdjunto, DashboardComunidadPublicacionItemDto, DashboardComunidadPublicacionRequestDto, DashboardComunidadPublicacionResponseDto, GenericResponse, GenericSearchResponse, LocalStorageKeys, SaveComunidadPublicacion, SearchComunidadPublicacionRequestDto, UploadComunidadPublicacionAdjuntoResponseDto} from "../model/index";
import { SharedFunctions } from '../../../../src/app/shared/shared.functions';


@Injectable({
    providedIn: 'root'
})
export class ComunidadPublicacionService extends CrudService<ComunidadPublicacion, number, SaveComunidadPublicacion, SearchComunidadPublicacionRequestDto>{
    
    private dashboardPublicacionesSubject: BehaviorSubject<DashboardComunidadPublicacionItemDto[]> = new BehaviorSubject<DashboardComunidadPublicacionItemDto[]>([]);
    public dashboardPublicacionesSubject$: Observable<DashboardComunidadPublicacionItemDto[]> = this.dashboardPublicacionesSubject.asObservable();

    constructor(protected _http: HttpClient, protected sharedFunctions: SharedFunctions){
        super(_http, 'ComunidadPublicacion', sharedFunctions);
    }

    refreshDashboardPublicaciones(data:DashboardComunidadPublicacionItemDto[]){
        this.dashboardPublicacionesSubject.next(data);
    }

    getAttachments(id: number): Observable<GenericResponse<ComunidadPublicacionAdjunto[]>> {
        return this._http.get<GenericResponse<ComunidadPublicacionAdjunto[]>>(this._serviceUrl + '/' + id + '/adjuntos', this.httpOptions);
    }

    uploadAttachTempUrl(): string {
        return this._serviceUrl + '/attach/temp';
    }

    uploadAttachTemp(p: any): Observable<GenericResponse<UploadComunidadPublicacionAdjuntoResponseDto>> {
        const formData = new FormData();
    
        if (p != null) {
          for (let i = 0; i < p.length; i++) {
            const file = p[i];
            if (file != null)
              formData.append('uploadFiles', file);
          }
        }
    
        return this._http.post<GenericResponse<UploadComunidadPublicacionAdjuntoResponseDto>>(this.uploadAttachTempUrl(), formData, this.httpFormDataOptions);
    }

    getDashboardPublicacionesUrl(): string {
        return this._serviceUrl + '/dashboard-comunidad-publicaciones';
    }
   
    getDashboardPublicaciones(p: DashboardComunidadPublicacionRequestDto): Observable<any>{
        var queryString = this.sharedFunctions.convertToQueryString(p);
        return this._http.get<any>( this.getDashboardPublicacionesUrl() + queryString, this.httpOptions);
    }
}